<template>
    <section id="page8">
        <div class="container">
            <div class="col-unique">
                <lottie-player :src="`animas/0/page09.json`" v-if="persona==0 && !$isMobile" ref="lottiepage9" id="page9anima0" 
                        loop="false"
                        transparent
                        style="width:100%">
                </lottie-player>
                <lottie-player :src="`animas/1/page09.json`" v-if="persona==1 && !$isMobile" ref="lottiepage9" id="page9anima1" 
                        loop="false"
                        transparent
                        style="width:100%">
                </lottie-player>

                <lottie-player :src="`animas/0/page09_mobile.json`" v-if="persona==0 && $isMobile" ref="lottiepage9" id="page9anima0" 
                        loop="false"
                        transparent
                        style="width:100%">
                </lottie-player>
                <lottie-player :src="`animas/1/page09_mobile.json`" v-if="persona==1 && $isMobile" ref="lottiepage9" id="page9anima1" 
                        loop="false"
                        transparent
                        style="width:100%">
                </lottie-player>
            </div>
        </div>
    </section>
</template>
<script>
import { create } from '@lottiefiles/lottie-interactivity';
export default {
    props: ['persona'],
    data() {
        return {
            mobile: false
        }
    },
    methods: {
        resizing() {
            if(this.mobile == false && document.documentElement.clientWidth <= 600) {
                this.mobile = true;
                this.configAnimation();

            } else if(this.mobile == true && document.documentElement.clientWidth > 600) {
                this.mobile = false;
                this.configAnimation();
            }
            console.log("Mobile = ", this.mobile);
        },
        configAnimation() {
            console.log("Call config animation");
            if(this.persona == 0) {
                this.$refs.lottiepage9.addEventListener('load', function() {
                    create({
                            mode:"scroll",
                            player: '#page9anima0',
                            actions: [
                                {
                                    visibility: [0, .2],
                                    type: "play"
                                }
                            ],
                    });
                })
            } else {
                this.$refs.lottiepage9.addEventListener('load', function() {
                    create({
                            mode:"scroll",
                            player: '#page9anima1',
                            actions: [
                                {
                                    visibility: [0, .2],
                                    type: "play"
                                }
                            ],
                    });
                })
            }
        }
    },
    mounted() {
        // window.addEventListener('resize', this.resizing);
        // if(document.documentElement.clientWidth > 600) {
        //     this.mobile = false;
        // } else {
        //     this.mobile = true;
        // }
        this.configAnimation();
        
    }
}
</script>
<style lang="scss" scoped>
section {
    background-color: #F7F7F8;
    color: $color-text-light;
    background-image: url("~@/assets/img/page8-bg.svg");
    background-repeat: no-repeat;
    background-size: auto;
    background-attachment: fixed;
    background-position: center top;
    .container {
        padding-top: 100px;
        padding-bottom: 100px;
    }
    .animapage9 {
        display: block;
    }
    .animapage9mobile {
        display: none;
    }

    @media only screen and (max-width: 600px) {
        .animapage9 {
            display: none;
        }
        .animapage9mobile {
            display: block;
        }
    }
}
</style>